import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import Lineinput from '../../../../common/lineinput'
import * as mdt from '../../../../common/modaltypes'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import AddandRemoveBtn from './AddandRemoveBtn'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const WeightChrgModal = ({ data, updateModal, updateAlertError, getWeightChrg, updateWeightChrg, getWeightChrgList }) => {
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const { headText, isUpdate, ConsignmentTypeList, loginData } = data
    const [weightChrg, setWeightChrg] = useState([])
    const [isActive, setIsActive] = useState(false)
    const [showData, setShowData] = useState(false)
    const [selConsignmentType, setSelConsignmentType] = useState('')
    useEffect(() => {
        focusElemnt('Consignment_Type')
    }, [])
    useEffect(() => {
        if (ConsignmentTypeList.length > 0) {
            setSelConsignmentType(ConsignmentTypeList[0])
        }
    }, [ConsignmentTypeList])
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const tableHeader = [
        { headerName: tr('fromNop', 'From NOP'), headerSx: { minWidth: "25%", textAlign: 'right' } },
        { headerName: tr('toNop', 'To NOP'), headerSx: { minWidth: "25%", textAlign: 'right' } },
        { headerName: tr('weightChargeMin', 'Weight Charge (Min)'), headerSx: { minWidth: "25%", textAlign: 'right' } },
        { headerName: tr('gsAction', 'Action'), headerSx: { minWidth: "25%", textAlign: 'left' } },
    ]
    const handleChangeWeightChrg = (event, field, index) => {
        let oldData = [...weightChrg.map((val, i) => i === index ? { ...val, [field]: event.target.value } : val)];
        if (field === 'FromNOP') {
            oldData[index - 1].ToNOP = event.target.value !== "" ? event.target.value - 1 : event.target.value
        }
        setWeightChrg(oldData)
    }
    const handleWeightChrg = (event, field, index) => {
        if (field === 'ToNOP' && isUpdate && parseInt(event.target.value) > 99999) {
            updateAlertError({ show: true, msg: tr('gsToNopMax', 'To NOP value should not exceed 99999'), nextId: `ToNOP-${index}` })
            resetWeightChrg(event, field, index)
        } else if (field === 'ToNOP' && isUpdate && event.target.value !== '' && (event.target.value !== '' ? parseInt(event.target.value) <= weightChrg[index].FromNOP : true)) {
            updateAlertError({ show: true, msg: tr('gsToNopGtFromNop', 'To NOP value should greater than FromNOP'), nextId: `ToNOP-${index}` })
            resetWeightChrg(event, field, index)
        } else if (field === 'FromNOP' && event.target.value !== '') {
            if (parseInt(event.target.value) <= weightChrg[index - 1].FromNOP) {
                updateAlertError({ show: true, msg: tr('gsGtPrev', 'Value must be greater than previous value'), nextId: `FromNOP-${index}` })
                resetWeightChrg(event, field, index)
            } else if ((weightChrg.length - 1) > index ? weightChrg[index + 1]?.FromNOP !== "" ? parseInt(event.target.value) >= weightChrg[index + 1]?.FromNOP : false : false) {
                updateAlertError({ show: true, msg: tr('gsLtNext', 'Value must be less than next value'), nextId: `FromNOP-${index}` })
                resetWeightChrg(event, field, index)
            } else if (parseInt(event.target.value) >= 99999) {
                updateAlertError({ show: true, msg: tr('gsFromNopMax', 'FromNOP should not exceed 99999'), nextId: `FromNOP-${index}` })
                resetWeightChrg(event, field, index)
            } else if (isUpdate && (index === 3 && weightChrg[index].ToNOP !== "" ? parseInt(event.target.value) > weightChrg[index].ToNOP : false)) {
                updateAlertError({ show: true, msg: tr('gsLtToNop', 'Value must be less than TONOP value'), nextId: `FromNOP-${index}` })
                resetWeightChrg(event, field, index)
            }
        }
    }
    const resetWeightChrg = (event, field, index) => {
        let oldData = [...weightChrg.map((val, i) => i === index ? { ...val, [field]: "" } : val)];
        if (field === 'FromNOP') {
            oldData[index - 1].ToNOP = ""
        }
        setWeightChrg(oldData)
    }
    const handleAddWeightChrg = (index) => {
        let newData = { FromNOP: '', ToNOP: weightChrg[index].ToNOP, MinimumWeightCharge: '' };
        let newArr = [...weightChrg.map((val, i) => i === index ? { ...val, "ToNOP": "" } : val)]
        newArr.splice(index + 1, 0, newData)
        setWeightChrg(newArr)
        if (newArr.length >= 4) {
            focusElemnt(`chrg-${index}`)
        }
    }
    const handleRemoveWeightChrg = (index) => {
        let oldToNOP = weightChrg[index].ToNOP
        let newData = weightChrg.filter((val, i) => i !== index)
        setWeightChrg([...newData.map((val, i) => (i === (index - 1)) ? { ...val, 'ToNOP': oldToNOP } : val)])
        focusElemnt(`chrg-${index - 1}`)
    }
    const hasEmptyValue = (array, properties) => {
        return array.some(obj => {
            return properties.some(prop => {
                const value = obj[prop];
                return value === '' || value == null;
            });
        });
    };
    const resetAllChrg = () => {
        setShowData(false)
        setWeightChrg([])
        setIsActive(false)
    }
    const getWeightChrgValue = () => {
        resetAllChrg()
        if (selConsignmentType === '' || selConsignmentType === " ") {
            updateAlertError({ show: true, msg: tr('gsSelCnsErr', 'Please Select Consignment Type'), nextId: 'Consignment_Type' })
        } else {
            const body = {
                CompanyID: loginData?.intCompanyID,
                ConsignmentTypeID: selConsignmentType?.ConsignmentSubTypeID
            }
            getWeightChrg(body).then((res) => {
                if (res.status === 'Success') {
                    if (!isUpdate && res.Data.Table.length > 0) {
                        updateAlertError({ show: true, msg: tr('gsWgtChgExists', 'Weight Charge already updated for Selected Consignment Type'), nextId: 'Consignment_Type' })
                    } else {
                        if (res.Data.Table.length > 0 && isUpdate) {
                            setShowData(true)
                            setWeightChrg(res.Data.Table.sort((a, b) => a.FromNOP - b.FromNOP))
                            setIsActive(res.Data.Table[0]?.IsActive === 1 ? true : false)
                        } else {
                            setShowData(true)
                            setWeightChrg([{ FromNOP: 1, ToNOP: 99999, MinimumWeightCharge: 0 }])
                            setIsActive(false)
                        }
                    }
                } else {
                    updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Consignment_Type' })
                }
            }).catch((err) => {
                console.log('Error:', err)
            })
        }
    }
    const handleSaveAndUpdateChrg = () => {
        const body = {
            CompanyID: loginData?.intCompanyID,
            UserID: loginData?.intUserID,
            ConsignmentTypeID: selConsignmentType?.ConsignmentSubTypeID,
            PayTypeCharge: weightChrg.map((val) => val.MinimumWeightCharge).join(','),
            PayTypeQty: weightChrg.map((val) => `${val.FromNOP}-${val.ToNOP}`).join(','),
            IsActive: isActive ? 1 : 0,
        }
        updateWeightChrg(body).then((res) => {
            if (res.status === 'Success') {
                resetAllChrg()
                updateModal(true, mdt.weightChrgConfModal)
            } else {
                updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    return (
        <Modal
            headTxt={headText}
            width={'50%'}
            updateModal={updateModal}
            closeId={"closeButton"}
            modalClass={'booking-popup'}
            modalStyle={modalStyle}

        >
            <Box sx={{ display: 'flex', padding: '15px' }}>
                <DropDownOA
                    id={"Consignment_Type"}
                    label={tr('gsSelCnsType', 'Select Consignment Type')}
                    defaultvalue={selConsignmentType?.SubType || selConsignmentType}
                    data={ConsignmentTypeList || []}
                    idKey={`ConsignmentSubTypeID`}
                    dataKey={`SubType`}
                    onSelect={(val) => {
                        resetAllChrg()
                        setSelConsignmentType(val)
                    }}
                    width="250px"
                    nextId={'goBtn'}
                    prevId={hasEmptyValue(weightChrg, ["FromNOP", "ToNOP", "MinimumWeightCharge"]) || !showData ? 'goBtn' : 'saveAndUpdateBtn'}
                />
                <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
                    <Button variant="contained" id={'goBtn'} sx={{ paddingY: '6px !important' }} onClick={() => {
                        getWeightChrgValue()
                    }} className="btn btn-primary"
                        onKeyDown={(e) => navigation3(e, weightChrg.length > 0 ? 'chrg-0' : 'Consignment_Type', 'Consignment_Type', () => { })}
                    >
                        {tr('gsGo', 'Go')}
                    </Button>
                </Item>
            </Box>
            <Box sx={{ display: 'flex', paddingX: '15px', marginBottom: '5px' }}>

                <TableContainer component={Paper} className='scroll' sx={{ marginBottom: "5px" }}>
                    <Table stickyHeader size="small" aria-label="a dense table"
                        sx={{
                            '& .MuiTableCell-root': {
                                padding: '6px 4px !important'
                            }
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                {tableHeader.map((row, index) => {
                                    return (
                                        <TableCell sx={{ ...row.headerSx, backgroundColor: '#DAEDFE', minHeight: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>
                                            {row.headerName}
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {showData ? weightChrg.map((row, index) => {
                                return (
                                    <TableRow >
                                        <TableCell>
                                            <div className={'input--wrapper btmSpaceNotRequired'}>
                                                <Lineinput
                                                    label={""}
                                                    id={`FromNOP-${index}`}
                                                    disabled={index === 0}
                                                    textAlign={'end'}
                                                    value={row.FromNOP}
                                                    onChange={(e) => handleChangeWeightChrg(e, "FromNOP", index)}
                                                    onBlur={(e) => handleWeightChrg(e, "FromNOP", index)}
                                                    onKeyDown={(e) => navigation3(e, isUpdate && index === 3 ? `ToNOP-${index}` : `chrg-${index}`, weightChrg.length >= 4 ? `chrg-${index - 1}` : `addBtn-${index - 1}`, () => { })}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className={'input--wrapper btmSpaceNotRequired'}>
                                                <Lineinput
                                                    label={""}
                                                    id={`ToNOP-${index}`}
                                                    disabled={isUpdate && index === 3 ? false : true}
                                                    value={row.ToNOP}
                                                    textAlign={'end'}
                                                    onChange={(e) => handleChangeWeightChrg(e, "ToNOP", index)}
                                                    onBlur={(e) => handleWeightChrg(e, "ToNOP", index)}
                                                    onKeyDown={(e) => navigation3(e, `chrg-${index}`, `FromNOP-${index}`, () => { })}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className={'input--wrapper btmSpaceNotRequired'}>
                                                <Lineinput
                                                    label={""}
                                                    id={`chrg-${index}`}
                                                    value={row.MinimumWeightCharge}
                                                    textAlign={'end'}
                                                    onChange={(e) => handleChangeWeightChrg(e, "MinimumWeightCharge", index)}
                                                    onBlur={(e) => handleWeightChrg(e, "MinimumWeightCharge", index)}
                                                    onKeyDown={(e) => navigation3(e, weightChrg.length >= 4 ? (weightChrg.length - 1) !== index ? `FromNOP-${index + 1}` : `removebtn-${index}` : `addBtn-${index}`, isUpdate && index === 3 ? `ToNOP-${index}` : index === 0 ? 'goBtn' : `FromNOP-${index}`, () => { })}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <AddandRemoveBtn addRow={handleAddWeightChrg} removeRow={handleRemoveWeightChrg} index={index} data={weightChrg}
                                                onKeyDownAdd={(e) => navigation3(e, (weightChrg.length - 1) === index ? index === 0 ? 'activeWeightCharge' : `removebtn-${index}` : `FromNOP-${index + 1}`, `chrg-${index}`, () => { })}
                                                onKeyDownRemove={(e) => navigation3(e, 'activeWeightCharge', weightChrg.length >= 4 ? `chrg-${index}` : `addBtn-${index}`, () => { })}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )
                            }) :
                                <TableRow>
                                    <TableCell colSpan={4} align='center' sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}>{tr('gsNoResult', 'No Result Found')}</TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>

                </TableContainer>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: 'end', paddingX: '15px' }}>
                <Item>
                    <FormControlLabel onChange={(e) => {
                        setIsActive(e.target.checked)
                    }}
                        onKeyDown={(e) => navigation3(e, hasEmptyValue(weightChrg, ["FromNOP", "ToNOP", "MinimumWeightCharge"]) || !showData ? 'Consignment_Type' : 'saveAndUpdateBtn', weightChrg.length === 1 ? `addBtn-0` : `removebtn-${weightChrg.length - 1}`, () => { })}
                        control={<Checkbox id={"activeWeightCharge"} checked={isActive} />}
                        label={
                            <Typography variant='h6' sx={{ fontWeight: '600' }}>
                                {tr('gsActWgtChg', 'Active Weight Charge')}
                            </Typography>
                        }
                    />
                </Item>
                <Item className="disabled-wrapper">
                    <Button variant="contained" id={'saveAndUpdateBtn'} disabled={hasEmptyValue(weightChrg, ["FromNOP", "ToNOP", "MinimumWeightCharge"]) || !showData} style={{ ...sx.fullHeight, ...sx.novp, padding: "6px 15px" }} className="btn btn-primary"
                        onClick={handleSaveAndUpdateChrg}
                        onKeyDown={(e) => navigation3(e, 'Consignment_Type', 'activeWeightCharge', () => { })}
                    >
                        {isUpdate ? tr('gsUpdate', 'UPDATE') : tr('gsSave', 'SAVE')}
                    </Button>
                </Item>
            </Box>
        </Modal>
    )
}

export default WeightChrgModal